import React, {ReactNode} from 'react';
import {Container} from 'react-bootstrap';
import {Header} from '../Header';
import styles from './Layout.module.scss';

export interface LayoutProps {
    children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({children}) => {
    return (
        <>
            <Header/>
            <main className={styles.mainContent}>
                <Container fluid="md" className="py-4">
                    {children}
                </Container>
            </main>
        </>
    );
};
